import { Link, useParams } from "react-router-dom";
import { useState } from "react";
import sources from "../../data/data"; // yo'lini mosla
import './DynamicRoute.css'

function DynamicRoute() {
  const { slug } = useParams();
  const [copied, setCopied] = useState(false);

  // barcha itemlar
  const allItems = Object.values(sources).flatMap(
    (cat) => cat.items
    
  );
  
  // slug match
  const item = allItems.find((i) => i.slug === slug);
  
  if (!item) {
    return <div className="pageNotFound">
      <h1> 404: Page not found </h1>
      <Link to={'/p/images'}>&lt; back</Link>
    </div>
  }

const handleCopy = async () => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(item.copyURL);
      setCopied(true);
    } catch (err) {
      fallbackCopy(item.copyURL);
    }
  } else {
    fallbackCopy(item.copyURL);
  }

  setTimeout(() => setCopied(false), 3000);
};

const fallbackCopy = (text) => {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";  // scrollga ta’sir qilmasligi uchun
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    document.execCommand("copy");
    setCopied(true);
  } catch (err) {
    alert("Copy failed, please copy manually");
  }
  document.body.removeChild(textarea);
};
  return (
    <div className="wraper">
      <img className="fullscreen" src={`/images/${item.path}`} alt={item.slug} />
      <div className="image-bottom">
         <Link className="image-bottom-a" to={'/p/images'}>See more..</Link>
         <p>|</p>
         <button onClick={handleCopy}> {copied ? "Copied" : "Copy link"} </button>
      </div>
    </div>
  );
}

export default DynamicRoute;
